document.addEventListener('DOMContentLoaded', () => { 
  const updateCartCount = () => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const countElement = document.querySelector('#custom-cart-icon p');
        if (countElement) {
          countElement.textContent = cart.item_count;
        }
      })
      .catch(err => console.warn('[DEBUG] error al actualizar carrito:', err));
  };

  // Escucha envíos de formularios de add/update
  document.body.addEventListener('submit', (e) => {
    if (e.target.matches('form[action*="/cart/add"], form[action*="/cart/update"]')) {
      setTimeout(updateCartCount, 200);
    }
  });

  // Intercepta fetch
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await origFetch(...args);
    const url = args[0];

    if (
      typeof url === 'string' &&
      (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))
    ) {

      // Actualiza tan pronto la respuesta esté lista
      response.clone().json().then(() => {
        updateCartCount();
      }).catch(() => {
        // fallback por si no es JSON o no tiene body legible
        setTimeout(updateCartCount, 800);
      });

      // fallback adicional por seguridad si Shopify se demora
      setTimeout(updateCartCount, 800);
    }

    return response;
  };

  // Shopify custom events
  ['cart:updated', 'cart:update', 'cart:change'].forEach(evt => {
    document.addEventListener(evt, () => {
      updateCartCount();
    });
  });
});


document.addEventListener('DOMContentLoaded', () => { 
  const updateCartCount = () => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const countElement = document.querySelector('#custom-cart-icon1 p');
        if (countElement) {
          countElement.textContent = cart.item_count;
        }
      })
      .catch(err => console.warn('[DEBUG] error al actualizar carrito:', err));
  };

  // Escucha envíos de formularios de add/update
  document.body.addEventListener('submit', (e) => {
    if (e.target.matches('form[action*="/cart/add"], form[action*="/cart/update"]')) {
      setTimeout(updateCartCount, 200);
    }
  });

  // Intercepta fetch
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await origFetch(...args);
    const url = args[0];

    if (
      typeof url === 'string' &&
      (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))
    ) {

      // Actualiza tan pronto la respuesta esté lista
      response.clone().json().then(() => {
        updateCartCount();
      }).catch(() => {
        // fallback por si no es JSON o no tiene body legible
        setTimeout(updateCartCount, 800);
      });

      // fallback adicional por seguridad si Shopify se demora
      setTimeout(updateCartCount, 800);
    }

    return response;
  };

  // Shopify custom events
  ['cart:updated', 'cart:update', 'cart:change'].forEach(evt => {
    document.addEventListener(evt, () => {
      updateCartCount();
    });
  });
});


//********** Banner */
      document.addEventListener('DOMContentLoaded', () => {
        const banner = document.getElementById('promo-banner');
        const closeBtn = document.getElementById('close-banner');
        const promoLink = document.getElementById('promo-link');
        const reopenBtn = document.getElementById('reopen-banner');

        // one time in session
        if (!sessionStorage.getItem('promoClosed')) {
          setTimeout(() => banner.classList.remove('hidden'), 1000);
        } else {
          reopenBtn.classList.remove('hidden');
        }

        // close banner
        const closeBanner = () => {
          banner.classList.add('hidden');
          reopenBtn.classList.remove('hidden');
          sessionStorage.setItem('promoClosed', 'true');
        };

        closeBtn.addEventListener('click', closeBanner);
        promoLink.addEventListener('click', closeBanner);

        // Reabrir banner desde el botón flotante
        reopenBtn.addEventListener('click', () => {
          banner.classList.remove('hidden');
          reopenBtn.classList.add('hidden');
        });
      });


// ********** Snow ************* */
      document.addEventListener('DOMContentLoaded', function () {
        const container = document.getElementById('snowfall');
        const numFlakes = 90; // Ajusta la cantidad de copos

        for (let i = 0; i < numFlakes; i++) {
          const snowflake = document.createElement('div');
          snowflake.classList.add('snowflake');
          snowflake.textContent = '*'; // Diseño del copo
          snowflake.style.left = Math.random() * 100 + 'vw';
          snowflake.style.animationDuration = 10 + Math.random() * 10 + 's';
          snowflake.style.fontSize = 8 + Math.random() * 14 + 'px';
          snowflake.style.animationDelay = Math.random() * 10 + 's';

          container.appendChild(snowflake);
        }
      });
      